
export const DashboardQueries = {
    "Canvas-Student Advising": "?Set%20Desired%20Average=60&Minimum%20Passing%20Grade=60",
    "Canvas-Student Advising BETA": "?Set%20Desired%20Average=60&Minimum%20Passing%20Grade=60",
    "Canvas-Student Course Performance": "?Set%20Desired%20Average=60&Minimum%20Passing%20Grade=60",
    "Canvas-Student Course Performance BETA": "?Set%20Desired%20Average=60&Minimum%20Passing%20Grade=60",
    "Assessment and Item Effectiveness": "?Desired%20Final%20Average=60&Minimum%20Passing%20Grade=60",
    "Assessment And Item Effectiveness": "?Desired%20Final%20Average=60&Minimum%20Passing%20Grade=60",
    "Curriculum Effectiveness and Gap Analysis": "?Student%20Performance%20Threshold=60&Minimum%20Passing%20Grade=60",
    "Student Academic Advising": "?Desired%20final%20average=60&Minimum%20Passing%20Grade=60",
    "Student Performance and Course Metrics": "?Desired%20final%20average=60&Minimum%20Passing%20Grade=60",
    "Students and Outcomes": "?At%20Risk%20Threshold=60&Minimum%20Passing%20Grade=60",
    "Students and Outcomes-Anonymized": "?At%20Risk%20Threshold=60&Minimum%20Passing%20Grade=60"
};